import { createVueApp } from '@/common/create_app'
import { defineComponent, h } from 'vue'

// Mailer Log has its own Vue app (separate Vite bundle) that mounts into #app.
// This styxie renders AppLayout (navbar) with #app container inside.
// The engine's module script (loaded via content_for :head) runs after this
// mount and finds #app ready.
const MailerLogHost = defineComponent({
  name: 'MailerLogHost',
  render: () => h('div', { id: 'app' })
})

Styxie.Initializers.MailerLogSpa = {
  index: async() => {
    createVueApp(MailerLogHost, { layoutProps: { noPadding: true } })
  }
}
